import React, {Component} from 'react';
import TYPE from '../Resources/TYPE';

const Button = ({href, text, classNames}) => (
	<a href={href}>
		<div className={"game-media-btn " + classNames}>
			{text}
		</div>
	</a>
)


class Header extends Component {
	constructor(props){
		super(props);

	}
	showMediaIcons(){
		const $mediaIcons = document.getElementsByClassName('global-media-btn');

		Object.keys($mediaIcons).map($currentIcon => $mediaIcons[$currentIcon].classList.add('is-active'))

		setTimeout(() => this.hideMediaIcons(), 5000)
	}

	hideMediaIcons(){
		const $mediaIcons = document.getElementsByClassName('global-media-btn');

		Object.keys($mediaIcons).map($currentIcon => $mediaIcons[$currentIcon].classList.remove('is-active'))
	}

	render() {

		const IMPORTANT = TYPE.IMPORTANT;
		const NORMAL = TYPE.NORMAL;

		const ImportantBtns = this.props.Buttons.filter(btn => btn.type === IMPORTANT)
		const NormalBtns = this.props.Buttons.filter(btn => btn.type === NORMAL)
		const {gameName, chapterName, fbLink, ytLink} = this.props;

		return (
			<header id="sgSectionHeader" className="gcAd-section game-header" data-section="1" onClick={this.showMediaIcons.bind(this)}>
				<div className="company-logo">
					<div className="logo">

					</div>
				</div>
				<div className="gcAd-title">
					{gameName}
				</div>
				<div className="game-media-list">
					<a href={ytLink}>
						<div className="global-media-btn yt-icon">

						</div>
					</a>
					<a href={fbLink}>
						<div className="global-media-btn fb-icon">

						</div>
					</a>
				</div>
				<div className="gcAd-subtitle">
					{chapterName}
				</div>
				<div className="gcAd-game-btns-important">
					{
						ImportantBtns
							.map(btn =>
								     <Button key={Object.keys(ImportantBtns)[ImportantBtns.indexOf(btn)]}
								             href={btn.href}
								             text={btn.text}
								             classNames={btn.classNames}
								     />)
					}
				</div>
				<div className="gcAd-game-btns">
					{
						NormalBtns
							.map(btn =>
								     <Button
									     key={Object.keys(NormalBtns)[NormalBtns.indexOf(btn)]}
									     href={btn.href}
									     text={btn.text}
									     classNames={btn.classNames}
								     />)
					}
				</div>
			</header>
		)
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Advert-Header.js